import { NJButton, NJModal, NJModalContent } from "@engie-group/fluid-design-system-react";
import styles from "./modal.module.css";
import { MarkdownMessage } from "@genai/chat";

export const ConfirmationModal = ({
  content,
  isOpen,
  onClose,
}: {
  content: string;
  isOpen: boolean;
  onClose: (confirm: boolean) => void;
}) => {
  return isOpen ? (
    <NJModal
      isOpen={true}
    >
      <NJModalContent
        id={"confirmation-modal"}
        onClose={onClose.bind(null, false)}
      >
      <p className={styles["genai-confirmation-modal-content"]}>
        <MarkdownMessage
          content={content}
        />
      </p>

      <div className={styles["genai-confirmation-modal-footer"]}>
        <NJButton
          label="Annuler"
          variant="secondary"
          onClick={onClose.bind(null, false)}
        />
        <NJButton
          label="Confirmer"
          variant="primary"
          onClick={onClose.bind(null, true)}
        />
      </div>
      </NJModalContent>
    </NJModal>
  ) : null;
};
